module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.showPage) ? _c('div', [_c('div', {
    staticClass: "package-title"
  }, [_c('div', {
    staticClass: "flex-row-sc"
  }, [_vm._v("\n      优惠券包\n      "), (_vm.couponPackageList && _vm.couponPackageList.length == 1) ? _c('span', {
    on: {
      "click": function($event) {
        _vm.showUseBox = true
      }
    }
  }, [_vm._v(_vm._s(_vm.couponPackageList[0].package_ttl) + "天内有效 | 使用说明\n      ")]) : _vm._e(), _vm._v(" "), (_vm.couponPackageList && _vm.couponPackageList.length == 1) ? _c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../assets/images/icon-warning.png"),
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "link",
    on: {
      "click": function($event) {
        return _vm.toRecord()
      }
    }
  }, [_vm._v("购买记录"), _c('span', {
    staticClass: "icon_arrow_next"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cpackage-list"
  }, [_vm._l((_vm.recordList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item",
      staticStyle: {
        "align-items": "center"
      }
    }, [_c('div', [_c('div', {
      staticClass: "fs-28 fw-bold"
    }, [_vm._v("您有订单未完成支付")]), _vm._v(" "), _c('div', {
      staticClass: "fs-24",
      staticStyle: {
        "margin-top": ".16rem"
      }
    }, [_vm._v(_vm._s(item.promotion_name) + "-" + _vm._s(item.coupon_num) + "张" + _vm._s(item.coupon_amount) + "元优惠券")])]), _vm._v(" "), _c('div', {
      staticClass: "btn-buy",
      staticStyle: {
        "margin-top": "0"
      },
      on: {
        "click": function($event) {
          return _vm.toRecord()
        }
      }
    }, [_vm._v("待支付")])])
  }), _vm._v(" "), _vm._l((_vm.couponPackageList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item"
    }, [_c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [_c('div', {
      staticClass: "img"
    }, [_c('div', {
      staticClass: "c-tit"
    }, [_vm._v(_vm._s(item.package_coupon_title))]), _vm._v(" "), _c('div', {
      staticClass: "c-price"
    }, [_c('span', [_vm._v(_vm._s(item.package_unit_price))]), _vm._v("元x"), _c('span', [_vm._v(_vm._s(item.package_unit_num))]), _vm._v("张\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "c-desc"
    }, [_vm._v(_vm._s(item.package_coupon_desc))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "3.2rem"
      }
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.package_name))]), _vm._v(" "), _c('div', [_vm._v("\n            " + _vm._s(item.package_status === 0 ? item.package_error : item.package_shop_desc) + "\n            "), _c('span', {
      staticStyle: {
        "color": "#5cb9ff",
        "margin-left": "0.1rem",
        "text-decoration": "underline"
      },
      on: {
        "click": function($event) {
          return _vm.viewShops(item)
        }
      }
    }, [_vm._v("去查看")])]), _vm._v(" "), _c('div', {
      staticClass: "price"
    }, [_vm._v("\n            ¥"), _c('span', [_vm._v(_vm._s(item.package_selling_price))])])])]), _vm._v(" "), _c('div', {
      staticClass: "btn-buy",
      class: item.package_status === 0 ? 'disabled' : '',
      on: {
        "click": function($event) {
          return _vm.openShowPay(item)
        }
      }
    }, [_vm._v("\n        立即购买\n      ")])])
  })], 2), _vm._v(" "), (_vm.couponPackageList && _vm.couponPackageList.length == 1) ? _c('div', {
    staticClass: "shop-list"
  }, [_c('div', {
    staticClass: "package-title"
  }, [_vm._v("以下为红包可用商家")]), _vm._v(" "), (_vm.packageShop.length > 0) ? _c('div', {
    staticClass: "goods-list shop"
  }, [_c('ul', {
    staticClass: "goods"
  }, _vm._l((_vm.packageShop), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('div', {
      staticClass: "goods-box"
    }, [_c('a', [_c('div', {
      staticClass: "goods-img",
      on: {
        "click": function($event) {
          return _vm.toGoodsList(item.id, item.shop_name)
        }
      }
    }, [_c('div', {
      staticClass: "lazy goodimg"
    }, [_c('img', {
      attrs: {
        "src": item.pic,
        "alt": ""
      }
    })]), _vm._v(" "), (item.is_mark == 1) ? _c('div', {
      staticClass: "mark",
      style: ({
        backgroundColor: item.mark_color
      })
    }, [_vm._v("\n                  " + _vm._s(item.mark) + "\n                ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "goods-des",
      on: {
        "click": function($event) {
          return _vm.toGoodsList(item.id, item.shop_name)
        }
      }
    }, [_c('div', {
      staticClass: "name ellipse"
    }, [_vm._v(_vm._s(item.shop_name))]), _vm._v(" "), _c('div', {
      staticClass: "comment",
      staticStyle: {
        "margin-top": "0.03rem"
      }
    }, [_c('CommentStars', {
      attrs: {
        "qualityCode": item.score
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.score))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#e3e3e3"
      }
    }, [_vm._v("|")]), _vm._v(" "), _c('span', [_vm._v("月售 " + _vm._s(item.sales_append) + "单")])], 1), _vm._v(" "), _c('div', {
      staticClass: "flex-row-bc"
    }, [_c('div', {
      staticClass: "threshold"
    }, [_c('span', {
      staticStyle: {
        "margin-right": "0.1rem"
      }
    }, [_vm._v("起送 ￥" + _vm._s(item.threshold_amount))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#e3e3e3"
      }
    }, [_vm._v("|")]), _vm._v(" "), (
      item.new_delivery_fee || item.new_delivery_fee === 0
    ) ? _c('div', [_c('span', {
      staticStyle: {
        "margin-right": "0"
      }
    }, [_vm._v("配送￥" + _vm._s(item.new_delivery_fee))]), _vm._v(" "), (item.is_many_delivery == 1) ? _c('span', [_vm._v("起")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#999",
        "text-decoration": "line-through",
        "margin-right": "0"
      }
    }, [_vm._v("￥" + _vm._s(item.delivery_fee))])]) : _c('div', [_c('span', {
      staticStyle: {
        "margin-right": "0"
      }
    }, [_vm._v("配送￥" + _vm._s(item.delivery_fee))]), _vm._v(" "), (item.is_many_delivery == 1) ? _c('span', [_vm._v("起")]) : _vm._e()]), _vm._v(" "), (item.delivery_type == 1) ? _c('span', [_vm._v("(商家配送)")]) : _vm._e()]), _vm._v(" "), (item.dinnerDuration) ? _c('div', [_vm._v(_vm._s(item.dinnerDuration))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "flex-row-bc"
    }, [(item.vice_title) ? _c('div', {
      staticClass: "vice_title"
    }, [_vm._v(_vm._s(item.vice_title))]) : _vm._e(), _vm._v(" "), (item.zsd) ? _c('div', {
      staticClass: "punctual-arrive"
    }, [_vm._v(_vm._s(item.zsd))]) : _vm._e()]), _vm._v(" "), (
      item.promotion_reduce && item.promotion_reduce.reduce_info
    ) ? _c('div', {
      staticClass: "promotion_reduce"
    }, _vm._l((item.promotion_reduce.reduce_info), function(item2, index2) {
      return _c('span', {
        key: index2,
        staticClass: "promotion_reduce-type border"
      }, [_vm._v(_vm._s(item2.meet_price) + "减" + _vm._s(item2.cut_price))])
    }), 0) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "promotion-and-coupon"
    }, [(item.promotion_list && item.promotion_list.length > 0) ? _c('div', {
      staticClass: "promotion"
    }, _vm._l((item.promotion_list), function(pro) {
      return _c('img', {
        staticClass: "icon",
        attrs: {
          "src": pro.icon_url,
          "width": "100%"
        }
      })
    }), 0) : _vm._e(), _vm._v(" "), (item.promotion_package && item.promotion_package.length > 0) ? _c('div', {
      staticClass: "package"
    }, _vm._l((item.promotion_package), function(proPackage, index5) {
      return _c('span', {
        key: index5
      }, [_vm._v(_vm._s(proPackage.package_desc))])
    }), 0) : _vm._e(), _vm._v(" "), (item.coupon_list && item.coupon_list.length > 0) ? _c('div', {
      staticClass: "coupon"
    }, [_vm._l((item.coupon_list), function(coupon, index6) {
      return _c('span', {
        key: index6,
        staticClass: "desc"
      }, [_vm._v(_vm._s(coupon.couponDes))])
    }), _vm._v(" "), _c('span', {
      staticClass: "get"
    }, [_vm._v("领券")])], 2) : _vm._e()]), _vm._v(" "), (item.is_open == 1 && item.is_book == 0) ? _c('span', {
      staticClass: "shop-status"
    }, [_vm._v("营业中")]) : (item.is_open == 1 && item.is_book == 1) ? _c('span', {
      staticClass: "shop-status can-reserve"
    }, [_vm._v("可预订")]) : _c('span', {
      staticClass: "shop-status close"
    }, [_vm._v("已打烊")]), _vm._v(" "), _c('div', {
      staticClass: "shop-type-box"
    }, [(item.is_self_take_new == 1) ? _c('span', {
      staticClass: "shop-type border"
    }, [_vm._v("自提")]) : _vm._e(), _vm._v(" "), (item.is_take_out == 1) ? _c('span', {
      staticClass: "shop-type border"
    }, [_vm._v("外送")]) : _vm._e(), _vm._v(" "), (item.is_eat_in == 1) ? _c('span', {
      staticClass: "shop-type eat-in border"
    }, [_vm._v("堂食")]) : _vm._e()])])])])
  }), 0)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showPayBox) ? _c('div', {
    staticClass: "mask over",
    on: {
      "click": function($event) {
        _vm.showPayBox = false
      },
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showPayBox) ? _c('div', {
    staticClass: "pay-box"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("确认购买")]), _vm._v(" "), _c('div', {
    staticClass: "cpackage-list"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('div', {
    staticClass: "img"
  }, [_c('div', {
    staticClass: "c-tit"
  }, [_vm._v(_vm._s(_vm.packageDetail.package_coupon_title))]), _vm._v(" "), _c('div', {
    staticClass: "c-price"
  }, [_c('span', [_vm._v(_vm._s(_vm.packageDetail.package_unit_price))]), _vm._v("元x"), _c('span', [_vm._v(_vm._s(_vm.packageDetail.package_unit_num))]), _vm._v("张\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "c-desc"
  }, [_vm._v(_vm._s(_vm.packageDetail.package_coupon_desc))])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.packageDetail.package_name))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#ff4a61",
      "padding-bottom": "0.16rem"
    }
  }, [_vm._v("\n              有效期至：" + _vm._s(_vm.packageDetail.package_sendTime) + "\n              "), _c('span', {
    staticClass: "leave-day"
  }, [_vm._v("剩余" + _vm._s(_vm.packageDetail.package_ttl) + "天")])]), _vm._v(" "), _c('div', [_vm._v("\n              " + _vm._s(_vm.packageDetail.package_shop_desc)), _c('span', {
    staticStyle: {
      "color": "#5cb9ff",
      "margin-left": "0.1rem",
      "text-decoration": "underline"
    },
    on: {
      "click": function($event) {
        return _vm.viewShops(_vm.packageDetail)
      }
    }
  }, [_vm._v("去查看")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "use-tips"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("使用说明")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.packageDetail.package_rule)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "to-pay",
    on: {
      "click": function($event) {
        return _vm.toPay()
      }
    }
  }, [_vm._v("\n      ¥" + _vm._s(_vm.packageDetail.package_selling_price) + "立即支付\n    ")])]) : _vm._e(), _vm._v(" "), (_vm.showUseBox) ? _c('div', {
    staticClass: "mask over",
    on: {
      "click": function($event) {
        _vm.showUseBox = false
      },
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showUseBox) ? _c('div', {
    staticClass: "pay-box"
  }, [_c('div', {
    staticClass: "use-tips"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("使用说明")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.packageDetail.package_rule)
    }
  })])]) : _vm._e()]) : _c('div', {
    staticClass: "nothing"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/empty-01.png")
    }
  }), _vm._v("\n    暂时没有可购的券包~\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-14864a5c","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/CouponPackage.vue
// module id = 413
// module chunks = 7